import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form, Button, Row, Col, Nav } from "react-bootstrap";
import "../styles/form.css";
import * as Yup from "yup";
import { Formik, FieldArray } from "formik";
import { NavLink } from "react-router-dom";
import ms from "ms";
import moment from "moment";
import { Plus, Dash } from "react-bootstrap-icons";
/* import { addPersonal, addAddress } from "../services/indexedDb"; */
import axios from "axios";
import useApi from "../hooks/useApi";

const Signup = () => {
	const initialState = {
		firstname: "",
		lastname: "",
		email: "",
		username: "",
		password: "",
		age: "",
		dob: "",
		addresses: [],
	};

	const minYear = ms("18y");
	const today = new Date().toISOString().slice(0, 10);
	const allUsers = [];

	const { fetchApi } = useApi();

	const [countries, setCountries] = useState([]);
	const [states, setStates] = useState([]);
	const [cities, setCities] = useState([]);
	const [userData, setUserData] = useState(initialState);
	const [minDate, setMinDate] = useState(null);
	const [users, setUsers] = useState([]);

	useEffect(() => {
		if (window.navigator.onLine) {
			getAllCountries();
		}
		if (JSON.parse(localStorage.getItem("users"))) {
			for (let user of JSON.parse(localStorage.getItem("users"))) {
				allUsers.push(user.username);
			}
			setUsers(allUsers);
		}
		const min_date = new Date(+new Date(today) - minYear);
		setMinDate(moment(min_date).format("YYYY-MM-DD"));
	}, []);

	const getAllCountries = async () => {
		const apiResponse = await fetchApi(
			"https://api.countrystatecity.in/v1/countries"
		);
		setCountries(apiResponse);
	};

	const handleOnChangeCountry = async (e) => {
		setUserData({ ...userData, country: e.target.value });
		const apiResponse = await fetchApi(
			`https://api.countrystatecity.in/v1/countries/${e.target.value}/states`
		);
		setStates(apiResponse);
	};

	const handleOnChangeState = async (e) => {
		setUserData({ ...userData, state: e.target.value });
		const apiResponse = await fetchApi(
			`https://api.countrystatecity.in/v1/countries/${userData.country}/states/${e.target.value}/cities`
		);
		setCities(apiResponse);
	};

	const handleLocalStorage = (values) => {
		let arr = [];
		if (localStorage.getItem("users") !== null) {
			arr = JSON.parse(localStorage.getItem("users"));
		}
		arr.push(values);
		localStorage.setItem("users", JSON.stringify(arr));
	};

	/* const handleLocalDB = async (values) => {
		const { addresses, ...personal } = values;
		if (addresses.length > 0 && !allUsers.includes(personal.username)) {
			let index = 0;
			while (index < addresses.length) {
				addresses[index].username = personal.username;
				addAddress(addresses[index]);
				index++;
			}
		}
		addPersonal(personal);
	}; */

	const date = new Date();

	const schema = Yup.object({
		firstname: Yup.string().required("First name is required"),
		lastname: Yup.string().required("Last name is required"),
		email: Yup.string().required().email("Email address is required"),
		username: Yup.string()
			.required("Username is required")
			.test(
				"unique-user",
				"Username is taken",
				(username) => !users.includes(username)
			),
		password: Yup.string()
			.required("Password is required.")
			.matches(
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
				"Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
			),
		age: Yup.number()
			.required("Age is required")
			.min(18, "Must be 18 years old"),
		dob: Yup.date()
			.required("Date of birth is required")
			.max(
				new Date(date.getFullYear() - 18, date.getMonth(), date.getDate()),
				"Must be 18 years old"
			),
		addresses: Yup.array().of(
			Yup.object({
				address1: Yup.string().required("Address Line 1 is required"),
				address2: Yup.string().required("Address Line 2 is required"),
				zip: Yup.string().required("ZIP Code is required"),
				city: Yup.string().required("City is required"),
				state: Yup.string().required("State is required"),
				country: Yup.string().required("Country is required"),
			})
		),
	});

	const sentenceCase = (s) => {
		if (typeof s !== "undefined") {
			return s.charAt(0).toUpperCase() + s.slice(1);
		}
	};

	return (
		<div className="container">
			<div className="form-container">
				<Row>
					<Col
						lg={4}
						md={12}
						style={{
							fontSize: 70,
							fontWeight: 600,
							margin: "auto",
							textAlign: "center",
						}}
					>
						Sign Up
					</Col>
					<Col lg={8} md={12}>
						<Formik
							validationSchema={schema}
							onSubmit={(users) => {
								handleLocalStorage(users);
								/* handleLocalDB(users); */
								let apiReq = setInterval(async () => {
									if (window.navigator.onLine) {
										await axios
											.post("http://localhost:8080/form", users)
											.then((res) => {
												console.log(res);
												clearInterval(apiReq);
											})
											.catch((err) => {
												console.warn(err);
											});
									}
								}, 1000);
							}}
							initialValues={initialState}
							validateOnMount={true}
						>
							{({
								handleSubmit,
								handleChange,
								isValid,
								values,
								errors,
								touched,
							}) => (
								<>
									<Form
										noValidate
										onSubmit={(e, users) => {
											handleSubmit(e);
											/* handleLocalDB(users); */
											e.preventDefault();
										}}
									>
										<fieldset>
											<legend>Personal Information</legend>
											<Row className="ps-3 pe-3">
												<Col md>
													<Form.Group className="mb-3 pb-3">
														<Form.Label>First Name</Form.Label>
														<Form.Control
															type="text"
															name="firstname"
															value={values.firstname}
															onChange={handleChange}
															isInvalid={errors.firstname}
														/>
														<Form.Control.Feedback
															className="position-absolute"
															type="invalid"
														>
															{sentenceCase(errors.firstname)}
														</Form.Control.Feedback>
													</Form.Group>
												</Col>
												<Col md>
													<Form.Group className="mb-3 pb-3">
														<Form.Label>Last Name</Form.Label>
														<Form.Control
															type="text"
															name="lastname"
															value={values.lastname}
															onChange={handleChange}
															isInvalid={errors.lastname}
														/>
														<Form.Control.Feedback
															className="position-absolute"
															type="invalid"
														>
															{sentenceCase(errors.lastname)}
														</Form.Control.Feedback>
													</Form.Group>
												</Col>
											</Row>
											<Row className="ps-3 pe-3">
												<Col md>
													<Form.Group className="mb-3 pb-3">
														<Form.Label>Email Address</Form.Label>
														<Form.Control
															type="email"
															name="email"
															value={values.email}
															onChange={handleChange}
															isInvalid={errors.email}
														/>
														<Form.Control.Feedback
															className="position-absolute"
															type="invalid"
														>
															{sentenceCase(errors.email)}
														</Form.Control.Feedback>
													</Form.Group>
												</Col>
												<Col md>
													<Form.Group className="mb-3 pb-3">
														<Form.Label>Username</Form.Label>
														<Form.Control
															type="text"
															name="username"
															value={values.username}
															onChange={handleChange}
															isInvalid={errors.username}
														/>
														<Form.Control.Feedback
															className="position-absolute"
															type="invalid"
														>
															{sentenceCase(errors.username)}
														</Form.Control.Feedback>
													</Form.Group>
												</Col>
												<Col md>
													<Form.Group className="mb-3 pb-3">
														<Form.Label>Password</Form.Label>
														<Form.Control
															type="password"
															name="password"
															value={values.password}
															onChange={handleChange}
															isInvalid={errors.password}
														/>
														<Form.Control.Feedback
															className="position-absolute"
															type="invalid"
														>
															{sentenceCase(errors.password)}
														</Form.Control.Feedback>
													</Form.Group>
												</Col>
											</Row>
											<Row className="ps-3 pe-3">
												<Col md>
													<Form.Group className="mb-3 pb-3">
														<Form.Label>Age</Form.Label>
														<Form.Control
															type="number"
															name="age"
															value={values.age}
															onChange={handleChange}
															isInvalid={errors.age}
														/>
														<Form.Control.Feedback
															className="position-absolute"
															type="invalid"
														>
															{sentenceCase(errors.age)}
														</Form.Control.Feedback>
													</Form.Group>
												</Col>
												<Col md>
													<Form.Group className="mb-3 pb-3">
														<Form.Label>Date of Birth</Form.Label>
														<Form.Control
															type="date"
															name="dob"
															value={values.dob}
															onChange={handleChange}
															isInvalid={errors.dob}
															max={minDate}
														/>
														<Form.Control.Feedback
															className="position-absolute"
															type="invalid"
														>
															{sentenceCase(errors.dob)}
														</Form.Control.Feedback>
													</Form.Group>
												</Col>
											</Row>
										</fieldset>
										<FieldArray
											name="addresses"
											render={(arrayHelpers) => (
												<>
													{values.addresses.map((address, index) => (
														<fieldset key={index}>
															<legend>Address #{index + 1}</legend>
															<Row className="ps-3 pe-3">
																<Col md>
																	<Form.Group className="mb-3 pb-3">
																		<Form.Label>Address Line 1</Form.Label>
																		<Form.Control
																			type="text"
																			name={`addresses[${index}].address1`}
																			value={values.addresses[index].address1}
																			onChange={handleChange}
																			isInvalid={
																				!values.addresses[index].address1
																					.length > 0
																			}
																		/>
																		<Form.Control.Feedback
																			className="position-absolute"
																			type="invalid"
																		>
																			Address Line 1 is required.
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md>
																	<Form.Group className="mb-3 pb-3">
																		<Form.Label>Address Line 2</Form.Label>
																		<Form.Control
																			type="text"
																			name={`addresses[${index}].address2`}
																			value={values.addresses[index].address2}
																			onChange={handleChange}
																			isInvalid={
																				!values.addresses[index].address2
																					.length > 0
																			}
																		/>
																		<Form.Control.Feedback
																			className="position-absolute"
																			type="invalid"
																		>
																			Address Line 2 is required
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md>
																	<Form.Group className="mb-3 pb-3">
																		<Form.Label>ZIP Code</Form.Label>
																		<Form.Control
																			type="text"
																			name={`addresses[${index}].zip`}
																			value={values.addresses[index].zip}
																			onChange={handleChange}
																			isInvalid={
																				!values.addresses[index].zip.length > 0
																			}
																		/>
																		<Form.Control.Feedback
																			className="position-absolute"
																			type="invalid"
																		>
																			Zip Code is required
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
															</Row>
															<Row className="ps-3 pe-3">
																<Col md>
																	<Form.Group className="mb-3 pb-3">
																		<Form.Label>Country</Form.Label>
																		<Form.Select
																			required
																			name={`addresses[${index}].country`}
																			value={values.addresses[index].country}
																			onChange={(e) => {
																				handleChange(e);
																				handleOnChangeCountry(e);
																			}}
																			isInvalid={
																				!values.addresses[index].country
																					.length > 0
																			}
																		>
																			<option></option>
																			{countries.map((ctry, index) => (
																				<option key={index} value={ctry.iso2}>
																					{ctry.name}
																				</option>
																			))}
																		</Form.Select>
																		<Form.Control.Feedback
																			className="position-absolute"
																			type="invalid"
																		>
																			Country is required
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md>
																	<Form.Group className="mb-3 pb-3">
																		<Form.Label>State</Form.Label>
																		<Form.Select
																			required
																			name={`addresses[${index}].state`}
																			value={values.addresses[index].state}
																			onChange={(e) => {
																				handleChange(e);
																				handleOnChangeState(e);
																			}}
																			isInvalid={
																				!values.addresses[index].state.length >
																				0
																			}
																		>
																			<option></option>
																			{states.map((state, index) => (
																				<option
																					key={index}
																					value={state.iso2}
																					onChange={handleChange}
																				>
																					{state.name}
																				</option>
																			))}
																		</Form.Select>
																		<Form.Control.Feedback
																			className="position-absolute"
																			type="invalid"
																		>
																			State is required
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
																<Col md>
																	<Form.Group className="mb-3 pb-3">
																		<Form.Label>City</Form.Label>
																		<Form.Select
																			name={`addresses[${index}].city`}
																			value={values.addresses[index].city}
																			required
																			onChange={handleChange}
																			isInvalid={
																				!values.addresses[index].city.length > 0
																			}
																		>
																			<option></option>
																			{cities.map((city, index) => (
																				<option
																					key={index}
																					value={city.name}
																					onChange={(e) => handleChange(e)}
																				>
																					{city.name}
																				</option>
																			))}
																		</Form.Select>
																		<Form.Control.Feedback
																			className="position-absolute"
																			type="invalid"
																		>
																			City is required
																		</Form.Control.Feedback>
																	</Form.Group>
																</Col>
															</Row>
															<Button
																type="button"
																onClick={() => arrayHelpers.remove(index)}
															>
																<Dash />
															</Button>
														</fieldset>
													))}
													<Button
														type="button"
														onClick={() =>
															arrayHelpers.push({
																address1: "",
																address2: "",
																zip: "",
																city: "",
																state: "",
																country: "",
															})
														}
													>
														<Plus />
													</Button>
												</>
											)}
										/>
										<Row className="ps-3 pe-3">
											<Col className="d-flex justify-content-center pb-2">
												<Button
													variant="primary"
													type="submit"
													disabled={!isValid}
													className="mt-3 mb-3"
												>
													Submit
												</Button>
											</Col>
										</Row>
										<Row className="ps-3 pe-3">
											<Col className="d-flex justify-content-center pb-2">
												<Nav activeKey="/home" className="center">
													<Nav.Item>
														<NavLink to="/login">Click here to Log In</NavLink>
													</Nav.Item>
												</Nav>
											</Col>
										</Row>
									</Form>
								</>
							)}
						</Formik>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default Signup;
